<!--  -->
<template>
  <div class="add_box">
    <el-table
      :data="list"
      border
      style="width: 100%;margin-top:20px"
    >
      <el-table-column
        min-width="100"
        label="名称"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>

      <el-table-column
        min-width="250"
        prop="leaderName"
        label="组长"
        align="center"
      >
        <template slot-scope="scope">
          <div class="groupbox">
            <div
              v-for="item,index in scope.row.leaders"
              :key="index"
              style="margin-right:10px"
            >
              <el-tag type="success">{{ item.leaderName }}</el-tag>
            </div>
          </div>

        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="work_status"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button
            :disabled="item.group_name===scope.row.title"
            type="warning"
            size="mini"
            @click="chooser(scope.row)"
          >选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <div>
      <el-button type="success">确定</el-button>
    </div> -->
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { getGroupList } from '@/api/authGroup'

export default {
  name: 'Domainname',
  components: {
    PaginationRight
  },
  data() {
    return {
      dialogVisible: false,
      total: null,
      adtype: null,
      query: {
        title: null,
        status: null,
        page: 1,
        page_size: 10
      },
      list: [],
      tableData: [],
      listLoading: false
    }
  },
  created() {},
  mounted() {},
  methods: {
    async menuList() {
      this.listLoading = true
      getGroupList(this.query).then(response => {
        this.list = response.data.list
        this.total = response.data.total
        this.listLoading = false
      })
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.menuList()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.menuList()
    },
    updatawe() {
      this.dialogVisible = false
      this.menuList()
    },
    sraw() {
      this.objr.page = 1
      this.objr.page_size = 10
      this.menuList()
    },
    reset() {
      this.objr.page = 1
      this.objr.page_size = 10
      this.objr.keyword = null
      this.objr.status = null
      this.menuList()
    },
    sendr(arr) {
      this.item = arr
      this.menuList()
    },
    chooser(item) {
      console.log(item)
      this.$emit('friendband', item, this.item)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.add_box {
  padding: 20px;
}
.defaultrse {
  color: #e6a23c;
}
.defaultr {
  color: #67c23a;
}
.stopew {
  color: red;
}
.fasrw {
  color: #409eff;
}
.sarch_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.sedrtw {
  width: 180px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 auto;
}
.sedrtwr {
  width: 380px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 auto;
}
</style>
